import Vorfallmanagement from "./Vorfallmanagement";

const NeuerSachverhaltDatumKeys: Set<keyof Vorfallmanagement.NeuerSachverhalt> = new Set([
  "NeuerSachverhaltDatum",
  "NeuerSachverhaltFristEnde",
] as (keyof Vorfallmanagement.NeuerSachverhalt)[]);

const DatumKeysVorfall: Set<keyof Vorfallmanagement.Vorfall | keyof Vorfallmanagement.Vorfall.Info> = new Set([
  "Feststellung",
  "BeginnVorfall",
  "FristEnde",
  "EndeVorfall",
] as (keyof Vorfallmanagement.Vorfall | keyof Vorfallmanagement.Vorfall.Info)[]);

const DatumKeysKorrespondenz: (keyof Vorfallmanagement.Korrespondenz)[] = [
  "BenachrichtigungVon",
  "BenachrichtigungBis",
  "Datum",
];

const DatumKeys = [...Array.from(DatumKeysVorfall), ...DatumKeysKorrespondenz];

const mapDatum = <T>(item: T) => {
  const temp = { ...item };
  DatumKeys.forEach((key) => {
    if (key in temp && (temp as any)[key]) {
      try {
        const date: string = (temp as any)[key];
        const mappedDate = new Date(date);
        (temp as any)[key] = mappedDate;
      } catch (error) {
        console.error(error);
      }
    }
  });
  return temp;
};

const mapSachverhaltDatum = <T>(item: T) => {
  const temp = { ...item };
  NeuerSachverhaltDatumKeys.forEach((key) => {
    if (key in temp && (temp as any)[key]) {
      try {
        const date: string = (temp as any)[key];
        const mappedDate = new Date(date);
        (temp as any)[key] = mappedDate;
      } catch (error) {
        console.error(error);
      }
    }
  });
  return temp;
};

const mapDatums = <T>(items: T[]) => {
  return items.map((c) => mapDatum<T>(c));
};

const mapKorrespondenz = <T>(item: T) => {
  return mapDatum(item);
};

const mapKorrespondenzen = <T>(items: T[]) => {
  return items.map(mapKorrespondenz);
};

const mapNeueSachverhalte = <T>(item: T) => {
  if ("NeueSachverhalte" in item) {
    let temp: any = { ...item };
    temp.NeueSachverhalte = temp.NeueSachverhalte.map(mapSachverhalt);
    return temp as T;
  }
  return item;
};

const mapSachverhalt = <T>(item: T) => {
  return mapSachverhaltDatum(item);
};

const mapVorfall = <T extends Vorfallmanagement.Vorfall>(vorfall: T) => {
  return [mapDatum, mapKorrespondenz, mapNeueSachverhalte].reduce((vorfall, func) => func(vorfall), vorfall);
};

const mapVorfaelle = <T extends Vorfallmanagement.Vorfall>(vorfaelle: T[]) => {
  return vorfaelle.map(mapVorfall);
};

const VorfallmanagementMapper = {
  mapDatum,
  mapDatums,
  mapKorrespondenz,
  mapKorrespondenzen,
  mapSachverhalt,
  mapVorfall,
  mapVorfaelle,
};

export default VorfallmanagementMapper;
